import { render, staticRenderFns } from "./ModalDuelsGame.vue?vue&type=template&id=531da1e7&scoped=true"
import script from "./ModalDuelsGame.vue?vue&type=script&lang=js"
export * from "./ModalDuelsGame.vue?vue&type=script&lang=js"
import style0 from "./ModalDuelsGame.vue?vue&type=style&index=0&id=531da1e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531da1e7",
  null
  
)

export default component.exports